var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortofolioBannerTablet(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 886.019,
    height: 484.681,
    viewBox: "0 0 886.019 484.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_3",
    "data-name": "Intersection 3",
    d: "M-3135.272,494.479c12.068-113.462,430.094-272.581,575.8-297.05s227.54-3.189,275.8,70.169,53.117,189.145-39.938,231.455-93.986,7.973-220.821,51.265-151.243,117.59-286.518,121.9c-4.021.128-8.094.192-12.19.192C-2976.84,672.418-3146.982,604.568-3135.272,494.479Z",
    transform: "translate(3135.845 -187.732)",
    fill: "#eda751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortofolioBannerTablet);
export default __webpack_public_path__ + "static/media/portofolioBannerTablet.06589d1ca97918acb770133ecc8c5d86.svg";
export { ForwardRef as ReactComponent };